import request from '@/utils/request'


// 查询科室认证信息列表
export function listAuth(query) {
  return request({
    url: '/depart/auth/list',
    method: 'get',
    params: query
  })
}

// 查询科室认证信息分页
export function pageAuth(query) {
  return request({
    url: '/depart/auth/page',
    method: 'get',
    params: query
  })
}

// 查询科室认证信息详细
export function getAuth(data) {
  return request({
    url: '/depart/auth/detail',
    method: 'get',
    params: data
  })
}

// 新增科室认证信息
export function addAuth(data) {
  return request({
    url: '/depart/auth/add',
    method: 'post',
    data: data
  })
}

// 修改科室认证信息
export function updateAuth(data) {
  return request({
    url: '/depart/auth/edit',
    method: 'post',
    data: data
  })
}

export function checkDepart(data) {
  return request({
    url: '/depart/auth/check',
    method: 'post',
    data: data
  })
}

// 删除科室认证信息
export function delAuth(data) {
  return request({
    url: '/depart/auth/delete',
    method: 'post',
    data: data
  })
}
